import combinedReducers from './reducers';

const reducers = {
  conceptCanvas: combinedReducers
};

export { reducers };
